var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { autoinject, transient } from "aurelia-framework";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { SweepstakeClientService } from "../../../../../services/modules/sweepstake-client-service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
var CreateSweepstakeDraw = /** @class */ (function () {
    function CreateSweepstakeDraw(notificationService, i18N, sweepstakeClientService, dialogClient) {
        this.notificationService = notificationService;
        this.i18N = i18N;
        this.sweepstakeClientService = sweepstakeClientService;
        this.dialogClient = dialogClient;
    }
    Object.defineProperty(CreateSweepstakeDraw.prototype, "isReadonly", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CreateSweepstakeDraw.prototype.activate = function (item) {
        if (!item || !item.sweepstakeId)
            return;
        this.vm = item;
    };
    CreateSweepstakeDraw.prototype.addNewDraw = function () {
        return __awaiter(this, void 0, void 0, function () {
            var requestModel;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.newDrawDate) {
                            this.notificationService.show(this.i18N.tr('validation-error') + "!", this.i18N.tr('draw-date-is-required'), NotificationType.Error);
                        }
                        requestModel = {
                            sweepstakeId: this.vm.sweepstakeId,
                            nextDrawDateLocal: this.newDrawDate
                        };
                        return [4 /*yield*/, this.sweepstakeClientService.createNewDraw(requestModel)
                                .then(function (response) {
                                // if response.created is not set or not true
                                if (!response || !response.created) {
                                    _this.notificationService.show(_this.i18N.tr('error-text') + "!", response && response.errorMessage ?
                                        response.errorMessage :
                                        _this.i18N.tr('error-creating-sweepstake-draw'), NotificationType.Error);
                                    return;
                                }
                                // used to just to show the updated date on the UI.
                                // can't update the property directly because of UOW will consider this as a change
                                _this.vm.updatedCurrentDrawDate = response.createdDraw.drawDateLocal;
                                _this.notificationService.show(_this.i18N.tr('success-text'), _this.i18N.tr('new-sweepstake-draw-added-and-marked-as-current'), NotificationType.Success);
                                _this.dialogClient.hide();
                            })
                                .catch(function (x) {
                                _this.notificationService.show(_this.i18N.tr('error-text') + "!", _this.i18N.tr('error-creating-sweepstake-draw'), NotificationType.Error);
                                return;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CreateSweepstakeDraw.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    CreateSweepstakeDraw = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            SweepstakeClientService,
            DialogClientService])
    ], CreateSweepstakeDraw);
    return CreateSweepstakeDraw;
}());
export { CreateSweepstakeDraw };
